import AuthorLayout from "@components/Layouts/AuthorLayout"
import { Hits } from "@components/Search/Hits"
import { getCurrentDomain } from "@utils/common"
import {
  GetServerSideProps,
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from "next"
import { NextSeo } from "next-seo"
import { renderToString } from "react-dom/server"
import { getServerState } from "react-instantsearch-core"

const AuthorPage = ({
  serverState,
  serverUrl,
  slug,
  domain,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <AuthorLayout
      serverUrl={serverUrl}
      serverState={serverState}
      slug={slug}
    >
      <NextSeo
        title={`Explore Books by ${slug}`}
        canonical={`${domain}/a/${slug}`}
        // TODO: Generate author descriptions using ChatGPT
        description={`Explore the captivating world of ${slug} at GZB.ae. 
        Discover their remarkable literary works and delve into their unique storytelling. 
        Immerse yourself in the compelling narratives created by this esteemed author. 
        Visit our online bookstore today and embark on an unforgettable reading journey.`}
      />
      <Hits />
    </AuthorLayout>
  )
}

export default AuthorPage

export const getServerSideProps: GetServerSideProps = async ({
  req,
  params,
}: GetServerSidePropsContext) => {
  const slug = params?.slug as string

  const protocol = req.headers.referer?.split("://")[0] || "https"
  const serverUrl = `${protocol}://${req.headers.host}${req.url}`
  const serverState = await getServerState(
    <AuthorPage
      serverUrl={serverUrl}
      slug={slug}
    />,
    {
      renderToString,
    }
  )

  const domain = getCurrentDomain()

  return {
    props: {
      serverState,
      serverUrl,
      slug,
      domain,
    },
  }
}
